// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import BootstarpVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import "@/assets/css/iconfont.js";
import "@/assets/css/style.css";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import svgIcon from "@/components/svgIcon.vue";
import "@/assets/font/font.css";
import i18n from "./locale/index";

Vue.use(ElementUI, { size: "small", zIndex: 3000 });
Vue.use(VueAwesomeSwiper);
Vue.use(BootstarpVue);
Vue.config.productionTip = false;

Vue.component("svgIcon", svgIcon);

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js